import { IconSocialTiktok, IconSocialYoutube, IconUploadFiles, IconArrowMedium, IconSocialBunnynet } from '../icons/svgs';
import VideoPreview from '../preview/VideoPreview';
import './VideoTemplate.scss';
import NextAction from "../actions/NextAction";
class VideoTemplate {
    structures() {
        return {
            title: {
                type: 'text',
                label: 'Title',
                placeholder: 'Create a cool title',
            },
            description: {
                label: 'Description',
                type: 'tinymce',
                placeholder: 'Description max 600 characters',
                rules: {
                    maxChar: 600, // 320 characters
                }
            },
            platform: {
                type: 'select',
                label: 'Select Platform',
                placeholder: 'Choose Platform', // version MVP: youtube & Tiktok only
                lists: [
                    {
                        value: 'youtube',
                        label: 'Youtube',
                        icon: <IconSocialYoutube />
                    },
                    {
                        value: 'tiktok',
                        label: 'Tiktok',
                        icon: <IconSocialTiktok />
                    },
                    {
                        value: 'bunnynet',
                        label: 'Bunnynet',
                        icon: <IconSocialBunnynet />
                    },
                    {
                        value: 'files',
                        label: 'Upload from Files',
                        icon: <IconUploadFiles />,
                        isDisabled: true,
                    }
                ]
            },
            url: {
                labelOnChangeOption: 'Embed Video URL',
                type: 'url',   // url with validate from select option
                helpText: 'Add video URL from Youtube, TikTok, or Embed code Bunnynet.',
                relatedRequired: ['youtube', 'tiktok', 'bunnynet'],
            },
            duration: {
                labelOnChangeOption: 'Add Video Duration',
                type: 'duration',  // in minutes, need convert to second for slide.duration
                helpText: 'Recommended min 1 max 300',
                relatedRequired: ['bunnynet'], // on Duration control not yet use
            },
            video: {
                labelOnChangeOption: 'Upload your video',
                type: 'video',   // file attachment max 1, allowed file type: MP3
                rules: {
                    allowedFileType: ['.mp4', '.mkv', '.avi', '.wmv', '.mov'],
                    maxFileSize: 1024 * 1024 * 1024, // 1GB
                    maxResolution: 720,
                },
            },
            thumbnails: {
                labelOnChangeOption: 'Upload Thumbnail (optional)',
                type: 'thumbnails',
                rules: {
                    allowedFileType: ['.jpg', '.jpeg', '.png', '.gif'],
                    maxFileSize: 2 * 1024 * 1024, // 2MB
                }
            },
        }
    }
    type() {
        return 'VideoTemplate';
    }

    name() {
        return 'Video';
    }
    iconType() {
        return 'video';
    }
    canRearrange() {
        return true;
    }
    canRenameLabel() {
        return true;
    }
    imageTemplate() {
        return (
            <div>
                <img src={require('../assets/img/template-image-video.jpg')} className='img-fluid' alt='video template' />
            </div>
        );
    }
    textHighlight() {
        let platformList = [];
        this.structures().platform.lists.map((item, key) => {
            platformList.push(item.label);
        });

        return (
            <div>
                <span className='text-muted'>It'll work well when you have the video material ready to embed via url, works best with </span>
                <span className='font-weight-700 text-dark'>{platformList.join(', ')}</span>
            </div>
        );
    }

    getDuration() {
        return 60;
    }

    render(data, index, inEditor) {
        return (
            <VideoPreview data={data} index={index} inEditor={inEditor} structures={this.structures()} />
        )
    }

    actions(data, index) {
        return (
            <NextAction label='Next' icon={<IconArrowMedium />} />
        );
    }
}


export default VideoTemplate;
